import styled from "styled-components";
import { Text } from '../../talent.styled';
import { BulletTitle } from "../about/about.styled";


export const StudyingTag = styled.span`
    color: #6A5ACD;
    background-color: #6A5ACD22;
    border-radius: 0.5rem ;
    padding: 0.15rem 0.5rem;
    margin-left: 0.25rem;
    font-size: 0.75rem;
    font-weight: 400;
`;

export const FormationList = styled.ul`
    list-style: none;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

export const FormationItem = styled.li``;

export const FormationTitle = styled(BulletTitle)`
    align-items: baseline;
    margin-bottom: 0.25rem !important;
    p {
        margin: 0 !important;
        margin-left: 0.5rem !important;
        font-size: 0.8rem;
    }
`;

export const SubText = styled(Text)`
    margin-top: 0 !important;
    margin-bottom: 0.25rem !important;
`;





